import * as React from "react";
import {OnFailure, OnSuccess, OnSuccessData} from "../../../../../store/action/actionHelpers";
import {connect} from "react-redux";
import {Dispatch} from "redux";
import Toast from "../../../../helper/Toast";
import Asset from "../../../../../model/asset/Asset";
import CreateAssetFormView from "./CreateAssetFormView";
import {addOrUpdateAssetAttachments, createAsset} from "../../../../../store/action/asset/asset";
import {none, option, Option} from "ts-option";
import {RouteComponentProps, withRouter} from "react-router";
import {Boxed} from "../../../../../hiberUiKit/src/molecules/Boxed/Boxed";
import PageHeaderView from "../../../../body/PageHeaderView";
import PageContentView from "../../../../body/PageContentView";
import Attachment from "../../../../../model/attachment/Attachment";
import AssetUploadHelper from "../../../../../helper/AssetUploadHelper";

interface IDispatchProps {
	/**
	 * Create asset.
	 * @param {asset} asset
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailure} onFailure
	 */
	createAsset: (asset: Asset, onSuccess: OnSuccessData<Asset>, onFailure: OnFailure) => void;
	/**
	 * Add attachments to asset
	 * @param {Asset} asset
	 */
	addOrUpdateAssetAttachments: (asset: Asset, attachments: Attachment[], onSuccess: OnSuccess, onFailure: OnFailure) => void;
}

interface IState {
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
	/**
	 * Image file of asset
	 */
	files: Option<(File | Attachment)[]>
}

type Props = IDispatchProps & RouteComponentProps<{}>;

class CreateAssetForm extends React.PureComponent<Props, IState> {
	constructor(props: Props) {
		super(props);
		this.state = {isSubmitting: false, files: none};
		this.onSubmit = this.onSubmit.bind(this);
		this.onAddOrUpdateFile = this.onAddOrUpdateFile.bind(this);
		this.onSubmitSuccess = this.onSubmitSuccess.bind(this);
		this.onSubmitFailure = this.onSubmitFailure.bind(this);
	}

	render() {
		return (
			<Boxed>
				<PageHeaderView header={"Create asset"}/>
				<PageContentView>
					<CreateAssetFormView onSubmit={this.onSubmit}
										 onCancel={this.props.history.goBack}
										 onAddOrUpdateFile={this.onAddOrUpdateFile}
										 isSubmitting={this.state.isSubmitting}/>
				</PageContentView>
			</Boxed>
		);
	}

	onAddOrUpdateFile(files: (File | Attachment)[]) {
		if (files.length > 0) {
			this.setState({files: option(files)})
		}
		else {
			this.setState({files: none})
		}
	}

	onSubmit(data: Asset) {
		this.setState({isSubmitting: true}, () => {
			this.props.createAsset(
				data,
				(asset) => {
					this.state.files.map((files: (File | Attachment)[]) => {
						AssetUploadHelper.uploadAssetFilesAndAttachments(files)
							.then(attachments => {
								this.props.addOrUpdateAssetAttachments(asset, attachments, this.onSubmitSuccess,
									this.onSubmitFailure)
							})
							.catch(this.onSubmitFailure);
					}).getOrElse(this.onSubmitSuccess);
				},
				() => this.onSubmitFailure("Asset creation failed")
			);
		});
	}

	onSubmitSuccess() {
		this.setState({isSubmitting: false}, () => {
			Toast.success("Asset created", "Asset create");
			this.props.history.goBack();
		});
	}

	onSubmitFailure(text: string) {
		this.setState({isSubmitting: false}, () => Toast.error(text, "Asset create"));
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		createAsset: (asset: Asset, onSuccess: OnSuccessData<Asset>, onFailure: OnFailure) => {
			dispatch(createAsset(asset, onSuccess, onFailure))
		},
		addOrUpdateAssetAttachments: (asset: Asset, attachments: Attachment[], onSuccess: OnSuccess, onFailure: OnFailure) =>
			dispatch(addOrUpdateAssetAttachments(asset, attachments, onSuccess, onFailure)),
	};
}

export default withRouter(connect(null, mapDispatchToProps)(CreateAssetForm));